import { Logo } from "./Logo";
import { WaIcon } from "./icons";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL, scrollToHash } from "@/lib/constants";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NAV = [
  { label: "Serviços", hash: "#servicos" },
  { label: "Como funciona", hash: "#como-funciona" },
  { label: "Regiões", hash: "#regioes" },
  { label: "FAQ", hash: "#faq" },
];

export default function Navbar({ user, onLogout }) {
  const handleLogout = async () => {
    try {
      await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include" });
    } finally {
      onLogout?.();
    }
  };

  return (
    <header data-testid="hidropro-navbar" className="fixed inset-x-0 top-0 z-50 border-b border-[rgba(10,92,140,0.14)] bg-paper/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-3 px-4 sm:px-6 lg:h-[72px] lg:px-8">
        <a
          href="#inicio"
          data-testid="hidropro-navbar-logo-link"
          onClick={(e) => {
            e.preventDefault();
            scrollToHash("#inicio");
          }}
          aria-label="HidroPro — início"
        >
          <Logo />
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((n) => (
            <a
              key={n.hash}
              href={n.hash}
              data-testid={`hidropro-navbar-${n.hash.replace("#", "")}`}
              onClick={(e) => {
                e.preventDefault();
                scrollToHash(n.hash);
              }}
              className="text-sm font-medium text-slate-600 transition-colors hover:text-[#0A5C8C]"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5 sm:gap-3">
          {user && (
            <div className="flex items-center gap-2.5" data-testid="hidropro-navbar-user">
              <img
                src={user.picture}
                alt=""
                referrerPolicy="no-referrer"
                className="h-8 w-8 rounded-full border-2 border-[#0A5C8C]/30 object-cover"
              />
              <span className="hidden font-display text-sm font-bold text-[#1A1A1A] lg:block">
                {user.name?.split(" ")[0]}
              </span>
              <button
                onClick={handleLogout}
                data-testid="hidropro-navbar-logout-button"
                className="flex h-9 items-center rounded-full border border-[rgba(10,92,140,0.3)] px-3.5 text-xs font-semibold text-slate-600 transition-colors hover:border-[#0A5C8C] hover:text-[#0A5C8C]"
              >
                Sair
              </button>
            </div>
          )}
          <a
            href={PHONE_TEL}
            data-testid="hidropro-navbar-phone-link"
            className="hidden font-mono text-sm font-medium text-[#1A1A1A] transition-colors hover:text-[#0A5C8C] lg:block"
          >
            {PHONE_DISPLAY}
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hidropro-navbar-whatsapp-button"
            className="inline-flex h-10 items-center gap-2 rounded-full bg-wa px-4 text-sm font-semibold text-white shadow-[0_6px_18px_rgba(37,211,102,0.3)] transition-all duration-300 hover:bg-wa-hover active:scale-[0.98] sm:h-11 sm:px-5"
          >
            <WaIcon className="h-4 w-4" />
            <span className="hidden lg:inline">Solicitar atendimento pelo WhatsApp</span>
            <span className="lg:hidden">WhatsApp</span>
          </a>
        </div>
      </div>
    </header>
  );
}
